<mat-card class="history-card">
  <!-- Two-row header (as you have it) -->
  <div class="header">
    <div class="row row-top">
      <div class="title-wrap">
        <mat-icon>history</mat-icon>
        <h2 class="title">Change History</h2>
        <span class="sub" *ngIf="referral">
          · Referral #{{ referral.id }} · {{ referral.referralType }}
        </span>
      </div>

      <div class="title-actions">
        <button mat-icon-button
                matTooltip="Refresh"
                (click)="refresh()"
                aria-label="Refresh change history">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </div>

    <div class="row row-actions">
      <mat-form-field appearance="outline" class="search">
        <mat-label>Search changes</mat-label>
        <input matInput placeholder="Field, value, or user"
               [value]="query()"
               (input)="query.set(($any($event.target)).value)" />
        <button *ngIf="query()" matSuffix mat-icon-button aria-label="Clear" (click)="query.set('')">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-slide-toggle [checked]="showOnlyChanged()"
                        (change)="showOnlyChanged.set($event.checked)"
                        color="primary">
        Show only changed fields
      </mat-slide-toggle>

      <span class="spacer"></span>

      <button mat-stroked-button (click)="expandAll()">Expand all</button>
      <button mat-stroked-button (click)="collapseAll()">Collapse all</button>

    </div>
  </div>

  <mat-card-content>
    <ng-container *ngIf="loading(); else contentTpl">
      <div class="skeleton">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    </ng-container>

    <ng-template #contentTpl>
      <ng-container *ngIf="!error(); else errTpl">
        <mat-accordion class="timeline" multi>
          <mat-expansion-panel *ngFor="let v of filtered(); trackBy: trackPanel"
                               class="history-panel"
                               [expanded]="isExpanded(v)"
                               (opened)="onOpened(v)"
                               (closed)="onClosed(v)">
            <mat-expansion-panel-header class="custom-header">
              <mat-panel-title>
                <div class="panel-header">
                  <span class="when">{{ v.atLocal | date:'medium' }}</span>
                  <span class="by" *ngIf="v.actorName">· {{ v.actorName }}</span>
                </div>
              </mat-panel-title>
              <mat-panel-description>
                {{ v.summary }}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="changes">
              <div class="change-row" *ngFor="let c of v.changes">
                <div class="label">{{ c.label }}</div>
                <div class="values h-scroll"
                     tabindex="0"
                     role="region"
                     [attr.aria-label]="'Changed value for ' + c.label">
                  <span class="pill old" [class.muted]="c.oldText === null">{{ c.oldText ?? '—' }}</span>
                  <span class="arrow">→</span>
                  <span class="pill new" [class.muted]="c.newText === null">{{ c.newText ?? '—' }}</span>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <div *ngIf="filtered().length === 0" class="empty">
          <mat-icon>info</mat-icon>
          No changes match your filters.
        </div>
      </ng-container>

      <ng-template #errTpl>
        <div class="error">
          <mat-icon>error</mat-icon>
          {{ error() }}
        </div>
      </ng-template>
    </ng-template>
  </mat-card-content>
</mat-card>
